export default "__VITE_ASSET__DleTon3J__"